import { Body } from '@cointracker/styleguide/src/LoggedIn';
import { useTranslation } from 'react-i18next';

export const ViewPermissions = () => {
  const { t } = useTranslation();
  return (
    <Body variant="body2" className="text-text-secondary">
      {t('add_wallet_modal.view_permissions')}
    </Body>
  );
};
